'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _session = require('../../../session');

var _session2 = _interopRequireDefault(_session);

var _feiseanna = require('../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _newFeisInvite = require('../../../new-feis-invite');

var _newFeisInvite2 = _interopRequireDefault(_newFeisInvite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.admin.invitations', ['ui.router', 'ngMaterial', 'ifeis.session', 'ifeis.feiseanna', 'ifeis.new-feis-invite']).config(function ($stateProvider) {
  $stateProvider.state('admin.invitations', {
    url: '/invitations',
    template: require('./tpl.html'),
    controller: 'AdminInvitationsController',
    ncyBreadcrumb: {
      label: 'Invitations',
      parent: 'admin.dashboard'
    }
  });
}).controller('AdminInvitationsController', function ($scope, fFeisService, fFeisInviteDialog) {
  $scope.invitations = [];

  $scope.create = function ($event) {
    fFeisInviteDialog($event).then(function (res) {
      return fFeisService.createInvite(res);
    }).then(function (invite) {
      $scope.invitations.push(invite);
    });
  };

  $scope.invalidate = function (invite) {
    fFeisService.invalidateInvite(invite.id).then(function () {
      refresh();
    });
  };

  function refresh() {
    $scope.loading = true;
    fFeisService.invites().then(function (invites) {
      $scope.loading = false;
      $scope.invitations = invites;
    });
  }

  refresh();
});


//////////////////
// WEBPACK FOOTER
// ./routes/admin/invitations/index.js
// module id = 515
// module chunks = 0